import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import PropTypes from "prop-types";
import AdsClickIcon from '@mui/icons-material/AdsClick';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GlobalConfirmationBox = ({
  title = "Action Confirmation",
  description,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  transitionDirection = "up",
  actionButtonName = "Open Dialog",
  startIcon,
  data
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(data);
    }
    handleClose();
  };

  return (
    <>
      <Button variant="outlined" onClick={handleClickOpen} startIcon={startIcon??<AdsClickIcon/>}>
        {actionButtonName}
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {title && <DialogTitle>{title}</DialogTitle>}
        {description && (
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {description}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleClose}>{cancelText}</Button>
          <Button onClick={handleConfirm} color="primary">
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// PropTypes for validation
GlobalConfirmationBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  transitionDirection: PropTypes.oneOf(["up", "down", "left", "right"]),
  actionButtonName: PropTypes.string,
};

export default GlobalConfirmationBox;
